const cf = {
  ver: 'debug',
  q2http_url: 'http://127.0.0.1:9585/icvs2/',
  flv_url: 'http://127.0.0.1:9585/',
  websocket_url: 'ws://127.0.0.1:9585/',

  connParams: {
    // - 登录平台IP
    address: '61.185.238.249',
    // - 端口
    port: '9988',
    // - 登录平台用户名
    user: 'ceshi',
    // - 登录平台密码
    password: 'Zcw123456',
    // - 登录平台企业ID
    epid: 'system',
    // - 登录平台是否通过网闸模式
    bfix: 1
  }

}

export default cf



// WEBPACK FOOTER //
// ./src/utils/JLYconfig.js